import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

export interface ClaimFileUploadErrorDialogData {
  fileNames: string[];
}

@Component({
  selector: 'app-claim-file-upload-error-dialog',
  templateUrl: './claim-file-upload-error-dialog.component.html',
  styleUrls: ['./claim-file-upload-error-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule, 
    MatButtonModule, 
    MatDialogModule
  ]
})
export class ClaimFileUploadErrorDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: ClaimFileUploadErrorDialogData) { }

}